import { OperationsFilterModel } from '@y42/json-schema';

export interface GlobalFilter {
  type: GlobalFilterType;
  filter: OperationsFilterModel;
}

export enum LocalFilterType {
  Widget = 'widget',
}
export enum GlobalFilterType {
  CanvasElement = 'canvas_element',
  DrilldownFilter = 'drilldown_filter',
}
export type WidgetFilterType = LocalFilterType | GlobalFilterType;

export interface WidgetFilterMetadata {
  label: string;
  textColor: string;
  backgroundColor: string;
}
